import Navbar from "@/components/marketing/Navbar.jsx";
import Footer from "@/components/marketing/Footer.jsx";
import { ChevronDown } from "lucide-react";

const faqs = [
  ["Which languages does DraftVoice support?", "English, Hindi, Telugu, and code-switched Mixed/Hinglish. We're adding more Indian languages soon."],
  ["How accurate is the voice transcription?", "We use OpenAI Whisper, the industry standard. Combined with your personal dictionary, accuracy is excellent for Indian names, brands and technical terms."],
  ["What's an output mode?", "Output modes shape the AI polish: Clean Text, Email, WhatsApp, AI Prompt, Client Brief, Blog Outline, Meeting Notes. Pick before recording for best results."],
  ["Can I use my own OpenAI API key?", "Yes — Pro / Team accounts will support bring-your-own-key for the AI step. Talk to us for early access."],
  ["Is my data private?", "Audio is sent only to OpenAI for transcription. Drafts are stored in your account. You can delete history any time."],
  ["What payment methods do you accept?", "Razorpay (UPI, cards, netbanking) and PhonePe. Refunds within 7 days, no questions asked."],
  ["Can I cancel anytime?", "Absolutely. Cancel from Billing and you'll keep access until the end of the period."],
  ["What about an unlimited plan?", "Yes — Unlimited at ₹699/month gives you fair-usage unlimited words plus priority polish and support. Perfect for daily creators, founders, and consultants."],
];

export default function FAQ() {
  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <section className="pt-16 pb-12 text-center bg-mesh">
        <div className="text-xs uppercase tracking-widest font-semibold text-brand-purple">FAQ</div>
        <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-brand-navy">Frequently asked.</h1>
      </section>
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 space-y-3">
          {faqs.map(([q, a], i) => (
            <details key={i} className="bg-white rounded-2xl border border-brand-borderc p-5 group">
              <summary className="font-semibold text-brand-navy cursor-pointer flex justify-between items-center">
                {q}
                <ChevronDown className="w-4 h-4 group-open:rotate-180 transition" />
              </summary>
              <p className="mt-2 text-sm text-brand-muted leading-relaxed">{a}</p>
            </details>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
